// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'phone-call';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M9.288 16.92c1.368.864 3.096.648 4.176-.432l.504-.504a1.13 1.13 0 0 0 0-1.584l-2.016-2.016a1.13 1.13 0 0 0-1.584 0 1.13 1.13 0 0 1-1.584 0L5.616 9.216c-.432-.432-.432-1.152 0-1.584s.432-1.152 0-1.584L3.6 4.032a1.13 1.13 0 0 0-1.584 0l-.432.504a3.287 3.287 0 0 0-.432 4.176c2.088 3.24 4.896 6.048 8.136 8.208zM8.424 6.192a3.38 3.38 0 0 1 3.384 3.384M8.424 3.384c3.384 0 6.192 2.736 6.192 6.192' />
    <path d='M8.424.576c4.968 0 9 4.032 9 9' />
  </g>
);

export const viewBox = '0 0 18 18';
